import { proxy } from "valtio";

export type ViewerMedia = { url: string; type: "image" | "video" };

// Global lightbox state. Holds the media group being viewed and the current
// index so the overlay can swipe between items (WhatsApp-style).
export const imageViewerStore = proxy<{ items: ViewerMedia[]; index: number }>({
  items: [],
  index: 0,
});

export const openViewer = (items: ViewerMedia[], index = 0) => {
  imageViewerStore.items = items;
  imageViewerStore.index = Math.max(0, Math.min(index, items.length - 1));
};

// Convenience for a single image.
export const openImage = (url: string) =>
  openViewer([{ url, type: "image" }], 0);

export const closeViewer = () => {
  imageViewerStore.items = [];
  imageViewerStore.index = 0;
};

export const viewerNext = () => {
  const n = imageViewerStore.items.length;
  if (n > 1) imageViewerStore.index = (imageViewerStore.index + 1) % n;
};

export const viewerPrev = () => {
  const n = imageViewerStore.items.length;
  if (n > 1) imageViewerStore.index = (imageViewerStore.index - 1 + n) % n;
};
